import { state } from '../state';
import { post } from '../api';
import { showModal, closeModal, modalFrame } from '../components/modal';
import { showToast } from '../components/toast';
import { validateRequired, clearAllErrors } from '../components/form-validation';
import { iconPlus, iconShield } from '../icons';
import type { Rule } from '../types';

function esc(str: string): string {
  const el = document.createElement('div');
  el.textContent = str;
  return el.innerHTML;
}

function ruleCard(r: Rule): string {
  const badge = r.active ? '<span class="badge badge-ok">active</span>' : '<span class="badge badge-muted">inactive</span>';
  return `
    <div class="list-card" data-rule-id="${r.id}">
      <div class="list-card-info">
        <div class="list-card-name">${iconShield()} ${esc(r.title)}</div>
        <div class="list-card-role">${esc(r.body.length > 120 ? r.body.slice(0, 120) + '...' : r.body)}</div>
      </div>
      ${badge}
    </div>`;
}

function openAddRule(reload: () => void): void {
  showModal(modalFrame('Add Rule',
    `<div class="form-group">
      <label class="form-label" for="f-title">Title</label>
      <input id="f-title" class="form-input" required>
    </div>
    <div class="form-group">
      <label class="form-label" for="f-body">Body</label>
      <textarea id="f-body" class="form-input" rows="5"></textarea>
    </div>`,
    `<button class="btn btn-secondary" id="modal-cancel">Cancel</button>
     <button class="btn btn-primary" id="modal-save">Save</button>`
  ));
  document.getElementById('modal-close')?.addEventListener('click', closeModal);
  document.getElementById('modal-cancel')?.addEventListener('click', closeModal);
  document.getElementById('modal-save')?.addEventListener('click', () => {
    clearAllErrors();
    if (!validateRequired('f-title', 'Title')) return;
    const title = (document.getElementById('f-title') as HTMLInputElement).value.trim();
    const bodyText = (document.getElementById('f-body') as HTMLTextAreaElement).value.trim();
    post<Rule>('/api/rules/add', { title, body: bodyText, server_id: state.currentServer })
      .then(() => { closeModal(); showToast('Rule added', 'ok'); reload(); })
      .catch(e => showToast(String(e), 'err'));
  });
}

export function renderRules(body: HTMLElement): void {
  const sid = state.currentServer;
  const rules = sid ? state.rules.filter(r => r.server_id === sid) : state.rules;
  const reload = (): void => renderRules(body);

  body.innerHTML = `
    <div class="channel-header">
      <h1>Rules</h1>
      <div class="channel-actions">
        <button class="btn btn-primary" id="add-rule">${iconPlus()} Add Rule</button>
      </div>
    </div>
    <div class="card-list">
      ${rules.length ? rules.map(r => ruleCard(r)).join('') : '<div class="empty-state"><p>No rules defined</p></div>'}
    </div>`;

  document.getElementById('add-rule')?.addEventListener('click', () => openAddRule(reload));
}
